import { useEffect, useState, useRef } from 'react'
import {produce, original, current} from 'immer'
import Popover from '@/components/Popover'
import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import PropTypes from 'prop-types';

const EformMultiSelectCheckbox = ({ items, placeholder, onChangeFunc, disable}) => {
	/*=================================================
		Filter Popup
	/================================================*/

    const [selectedGroup, setSelectedGroup] = useState();
	const [filterVisible, setFilterVisible] = useState(false)
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

    useEffect(() => {
        const index = items.findIndex(field => field.$selected === true);
        if (index < 0) {
            return setSelectedGroup()
        }
		return setSelectedGroup(items[index].groupId);
    }, [items])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
		setFilterVisible(false)
	}

	if ((Array.isArray(items))) {
		const count = items.filter(item => item.$selected === true).length;
		const selectedOptions = items.filter(item => item.$selected === true);


		function changeListCheckboxes(event) {
			const index = items.findIndex(field => field.value == event.target.value);
			const updatedItem = produce(items, draft => {
                draft[index].$selected = !draft[index].$selected
                setSelectedGroup(draft[index].groupId);
			})
			onChangeFunc(updatedItem)
		}

		const list = items.map((field, index) => {
			return (
				<div className="eform-group__content__column" key={index}>
					<input type="checkbox"
						name={field.label || field.name}
						className="eform-group__content__checkbox"
						value={field.value}
						id={field.value}
						checked={field.$selected}
						onChange={(e) => changeListCheckboxes(e)}
                        disabled={selectedGroup && field.groupId !== selectedGroup}
					/>
					<label htmlFor={field.value}>{field.label || field.name}</label>
				</div>
			)
		})

		return (

			<div className="multiCheckboxSelect__group">
				<Popover visible={filterVisible}
					options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] }}]  }}
				>
					<Popover.Trigger>
						<div className={`multiCheckboxSelect__trigger ${disable ? "multiCheckboxSelect--disabled":""} multiCheckboxSelect__trigger-wrapped`} onClick={() => {
							if (!disable) {
								setFilterVisible(!filterVisible)
							}
						}} data-testid="multi-checkbox-select-trigger">
							{
								count > 0 && disable && (selectedOptions?.map((option)=>{
									return (
										<div key={`${option?.value}-${option?.label}`} className="multiCheckboxSelect__selected multiCheckboxSelect__placeholder-text multiCheckboxSelect--chip">
											{option?.label}
										</div>
									)

								}))
							}
							{
								count > 0 && !disable && (
									<span className="multiCheckboxSelect__selected multiCheckboxSelect__placeholder-text">
										{count} Selected
									</span>
								)
							}
							{
								(count === 0) && (
									<span className="multiCheckboxSelect__placeholder-text" data-testid="multiCheckboxSelect__placeholder-text">
										{disable ?  'No Item Selected' : placeholder }
									</span>
								)
							}
							{!disable &&  <IconChevronDown />}
						</div>
					</Popover.Trigger>

					<Popover.Content>
						<div className="multiCheckboxSelect__content" ref={referenceRef} >
							<div className="multiCheckboxSelect__group__content">
								<div className="multiCheckboxSelect__group__content__cols">
									{
										list.length > 0 && (
											<>
												{list}
											</>
										)
									}
                                    {
										list.length === 0 && (
											<>
												{"No Data Available"}
											</>
										)
									}
								</div>
							</div>
						</div>
					</Popover.Content>
				</Popover>
			</div>

		)
	}
}

EformMultiSelectCheckbox.propTypes = {
	items: PropTypes.arrayOf(
	  PropTypes.shape({
		$selected: PropTypes.bool,
		value: PropTypes.number,
		label: PropTypes.string,
	  })
	),
	placeholder: PropTypes.string,
	onChangeFunc: PropTypes.func,
	disable: PropTypes.bool,
  };

export default EformMultiSelectCheckbox
